// extracted by mini-css-extract-plugin
export default {"word":"WordWithTooltip_word__3FM-3","word_active":"WordWithTooltip_word_active__S8jLA"};